import "@hotwired/turbo-rails";
import "@rails/actiontext";
import * as ActiveStorage from "@rails/activestorage";
import ahoy from "ahoy.js";
import "cally";
import "trix";

import "./channels";
import "./controllers";
import "./initializers/lazy_loading";

ActiveStorage.start();

import LocalTime from "local-time";
LocalTime.start();

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

// Track custom events
ahoy.configure({
  urlPrefix: "",
  visitsUrl: "/ahoy/visits",
  eventsUrl: "/ahoy/events",
  page: null,
  platform: "Web",
  useBeacon: true,
  startOnReady: true,
  trackVisits: true,
  cookies: true,
  cookieDomain: null,
  headers: {},
  visitParams: {},
  withCredentials: false,
  visitDuration: 4 * 60, // 4 hours
  visitorDuration: 2 * 365 * 24 * 60, // 2 years
});

ahoy.trackView();
ahoy.trackClicks("a, button, input[type=submit]");
ahoy.trackSubmits("form");

document.addEventListener("turbo:morph", () => {
  LocalTime.run();
});

// Google Tag Manager
document.addEventListener("turbo:load", () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,
  });
});
